import React, { useEffect } from "react";
import TwoCellRow from "components/TwoCellRow";
import CustomFormatNumber from "components/CustomFormatNumber";
import PrevButton from "components/PrevButton";
import NextButton from "components/NextButton";
import { useFormattedMessage, useSideModalScrollToTop } from "hooks";

const leftClass = "mb-9 d-block";
const rightClass = "text-14 fw-600 d-block mb-9";

const messages = {
    soEditWalletMainHeading: "create_purchase_offer",
    boOTPAcceptMainHeading: "buy_digital_shares",
    boWalletHeading: "create_purchase_heading",
    soEditWalletHeading: "accept_sales_offer",
    boEditWalletContent: "pay_with_available_balance",
    boEditWalletBalanceTitle: "available_balance",
    purchasePrice: "purchase_price",
    purchaseFee: "purchase_fee",
    totalPurchasePrice: "total_purchase_price",
    remainingCredit: "remaining_credit",
    boEditWalletNoteTitle: "note",
    soEditWalletNoteContent: "blocked_in_your_ewallet",
};

const WalletOverview = ({
    className = "",
    onBack,
    onForward,
    setCloseTitle,
    payInAmount,
    isOfferAccepted,
    stepData,
    backSlideEffect = "",
}) => {
    useSideModalScrollToTop();

    const { formatMessage } = useFormattedMessage();

    useEffect(() => {
        setCloseTitle(
            isOfferAccepted ? formatMessage(messages.boOTPAcceptMainHeading) : formatMessage(messages.soEditWalletMainHeading)
        );
    }, []);

    return (
        <>
            <div className={`buy-order-wallet-overview ${className} ${backSlideEffect}`}>
                <h3>{isOfferAccepted ? formatMessage(messages.soEditWalletHeading) : formatMessage(messages.boWalletHeading)}</h3>
                <p>{formatMessage(messages.boEditWalletContent)}</p>
                <div className="top-grey-div bg-dark hf-35 flex-column justify-center align-center mt-10">
                    <span className="d-inline-block text-16 fw-500 mb-2">{formatMessage(messages.boEditWalletBalanceTitle)}</span>
                    <span className="d-inline-block text-34 fw-600">
                        <CustomFormatNumber value={payInAmount} />
                    </span>
                </div>
                <div className="wallet-overview-details px-3 pt-10">
                    <TwoCellRow
                        removeLClass
                        removeRClass
                        lClassname={leftClass}
                        rClassname={rightClass}
                        left={formatMessage(messages.purchasePrice)}
                        right={<CustomFormatNumber value={stepData.purchasePrice} />}
                    />
                    <TwoCellRow
                        removeLClass
                        removeRClass
                        lClassname={leftClass}
                        rClassname={rightClass}
                        left={`${formatMessage(messages.purchaseFee)} (${stepData.purchaseFeePercent}%):`}
                        right={<CustomFormatNumber value={stepData.purchaseFee} />}
                    />
                    <TwoCellRow
                        removeLClass
                        removeRClass
                        lClassname={leftClass}
                        rClassname={rightClass}
                        left={formatMessage(messages.totalPurchasePrice)}
                        right={<CustomFormatNumber value={stepData.totalPurchasePrice} />}
                    />
                    <TwoCellRow
                        removeLClass
                        removeRClass
                        lClassname={leftClass}
                        rClassname={rightClass}
                        left={formatMessage(messages.remainingCredit)}
                        right={<CustomFormatNumber value={stepData.remainingCredit} />}
                    />
                </div>
                <h4>{formatMessage(messages.boEditWalletNoteTitle)}</h4>
                <p>{formatMessage(messages.soEditWalletNoteContent)}</p>
            </div>
            <div className="bottom-bar-container">
                <PrevButton onClick={onBack} />
                <NextButton onClick={onForward} />
            </div>
        </>
    );
};

export default WalletOverview;
